import styled from 'styled-components';
import { Flex, OverflowTooltip } from '@elementary/common-ui/components';
import CopyButton from 'shared/components/CopyButton';
import { isIncidentReadOnly } from '../../utils/incidentState';
import type { IncidentDetail } from '../../types';

const TitleRow = styled(Flex)`
  align-items: center;
  gap: 8px;
`;

type Props = {
  incident: IncidentDetail;
};

const IncidentHeader = ({ incident }: Props) => {
  const isReadOnly = isIncidentReadOnly(incident);

  return (
    <TitleRow>
      <OverflowTooltip
        typographySx={{
          fontWeight: '500 !important',
        }}
        sx={{ fontSize: '14px' }}
      >
        {incident.title}
      </OverflowTooltip>
      {!isReadOnly && (
        <CopyButton
          textToCopy={incident.title}
          sx={{ height: '20px', width: '20px', flexShrink: 0 }}
        />
      )}
    </TitleRow>
  );
};

export default IncidentHeader;
